const colors = {
  /** Tailwind-aligned neutrals for body ink / icons (WCAG on secondary-50). */
  GRAY: {
    500: '#6b7280',
    600: '#475569',
    700: '#374151',
    900: '#111827'
  },
  WHITE: '#ffffff',
  /**
   * @deprecated Prefer Tailwind `semantic.*` theme colors from `tailwind.config.js`
   * (e.g. `bg-semantic-streak`, `text-semantic-error`, `dark:bg-semantic-streak-highlight-dark`).
   * Kept for legacy SVG `fill` / `fillDarkMode` props until those call sites migrate to
   * `currentColor` + semantic text utilities. Do not add new `COLOR.SEMANTIC` usages.
   */
  SEMANTIC: {
    INFO: '#0674db',
    INFO_STRONG: '#2563eb',
    INFO_SOFT: '#3b82f6',
    WARNING: '#9F5D15',
    SUCCESS: '#16a34a',
    ERROR: '#dc2626',
    ERROR_SOFT: '#DD6F59',
    SWITCH_OFF: '#D03131',
    STREAK: '#FF6333',
    STREAK_MUTED: '#AAB0BB',
    STREAK_HIGHLIGHT: '#FFE8E0',
    STREAK_HIGHLIGHT_DARK: 'rgba(255, 99, 51, 0.28)'
  },
  PRIMARY: {
    LIGHT_50: '#FFF4E9',
    LIGHT_100: '#FFE4C6',
    LIGHT_200: '#FFC88B',
    LIGHT_300: '#FAB363',
    LIGHT_400: '#F3A650',
    LIGHT_500: '#E9902C',
    LIGHT_600: '#D17F1F',
    LIGHT_700: '#B86E1A',
    LIGHT_800: '#9F5D15',
    LIGHT_900: '#864C10',
    DARK_50: '#2C1F0F',
    DARK_100: '#3D2A15',
    DARK_200: '#4E351B',
    DARK_300: '#5F4021',
    DARK_400: '#704B27',
    DARK_500: '#E9902C',
    DARK_600: '#F3A650',
    DARK_700: '#FAB363',
    DARK_800: '#FFC88B',
    DARK_900: '#FFE4C6'
  },
  SECONDARY: {
    LIGHT_50: '#FCF8F0',
    LIGHT_100: '#F8F3EA',
    LIGHT_200: '#F1E9DD',
    LIGHT_300: '#E3D5C3',
    LIGHT_400: '#D5C1A9',
    LIGHT_500: '#CCB8A1',
    LIGHT_600: '#C4B09A',
    LIGHT_700: '#B39F8B',
    LIGHT_800: '#A28E7C',
    LIGHT_900: '#917D6D',
    DARK_50: '#1A1815',
    DARK_100: '#25221E',
    DARK_200: '#302C27',
    DARK_300: '#3B3630',
    DARK_400: '#464039',
    DARK_500: '#514A42',
    DARK_600: '#5C544B',
    DARK_700: '#675E54',
    DARK_800: '#72685D',
    DARK_900: '#E3D5C3'
  }
};

/** Soft multi-hue accents for untimeboxed (anytime) timeline tasks. */
export const UNTIMED_TASK_COLOUR_PALETTE = [
  '#ec4899', // pink
  '#f472b6', // light pink
  '#fb7185', // rose
  '#f59e0b', // amber
  '#eab308', // yellow
  '#14b8a6', // teal (cooler accent)
  '#3b82f6' // blue (cooler accent)
] as const;

/** Distinct cursor colours for project-note collab awareness. */
export const PROJECT_NOTE_CURSOR_COLOUR_PALETTE = [
  '#F97316',
  '#3B82F6',
  '#10B981',
  '#8B5CF6',
  '#EF4444',
  '#EC4899',
  '#14B8A6',
  '#F59E0B'
] as const;

export const DEFAULT_PROJECT_STATUS_COLORS = {
  TO_DO: '#6B7280',
  IN_PROGRESS: '#F59E0B',
  DONE: '#10B981'
} as const;

export default colors;
